import React from 'react'
import { oneOf, string } from 'prop-types'

export const EmbedWrapper = ({ type, id, vimeoId, ...other }) => {
  if (type === 'youtube') return <div id={id} {...other} />
  if (type === 'vimeo')
    return <div id={id} data-vimeo-id={vimeoId} {...other} />
  return null
}

EmbedWrapper.propTypes = {
  type: oneOf(['youtube', 'vimeo']).isRequired,
  id: string,
  vimeoId: string
}
